<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Change Space Assignment of Storage</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form 
          class="modal-card-body"
          :key="warehouseId" 
          :valid.sync="valid">

          <div class="columns" v-if="currentLocation">
            <div class="column is-half">
              <label class="label">
                Current Warehouse
              </label>
              <div>
                ({{ currentLocation.warehouse.warehouse_code }}) 
                {{ currentLocation.warehouse.warehouse_name }}
              </div>
            </div>

            <div class="column is-half">
              <label class="label">
                Current Location
              </label>
              <div>
                ({{ currentLocation.location_code }})
                {{ currentLocation.location_name }}
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column is-half">
              <label class="label">Warehouse*</label>
              <v-select
                required
                v-if="!loading"
                item-text="warehouse_name"
                item-value="id"
                :options="warehouses"
                v-model="warehouseId"
              />
            </div>

            <div class="column is-half">
              <label class="label">Warehouse Location*</label>
              <v-select
                v-if="warehouseId"
                required
                item-text="location_name"
                item-value="id"
                :options="warehouse.locations"
                v-model="storage.warehouse_location_id"
              />
              <div v-else class="has-text-grey-light mt-2">
                Please select a warehouse
              </div>
            </div>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="save()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>

    </div>

  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VSelect from '@/components/base/VSelect'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    currentLocation: {
      type: Object
    },
    storage: {
      type: Object
    }
  },
  components: { 
    VForm,
    VSelect
  },
  data() {
    return {
      warehouseId: null,
      warehouseLocationId: null,
      valid: false
    }
  },
  computed: {
    ...mapState("warehouses", 
      ["warehouses", "loading"]
    ),
    warehouse() {
      return this.warehouses.filter(d => d.id == this.warehouseId)[0];
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("warehouses", ["getWarehouses"]),
    ...mapActions("warehouseLocation", ["changeStorageLocation"]),
    initialize() {
      if (this.warehouses.length == 0) {
        this.getWarehouses({ per_page: 100 });
      }
    },
    save() {
      this.changeStorageLocation({
        locationId: this.currentLocation.id,
        storageId: this.storage.id,
        data: {
          warehouse_location_id: this.warehouseLocationId
        }
      })
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
.label-and-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .tag {
    cursor: pointer;
    &:hover {
      background: gainsboro;
    }
  }
}
</style>
